/* Maitre Couture — sitegedrag.
   Twee dingen: de gallerypuntjes en de bezwaren. Verder doet CSS of de
   browser het zelf. Accordeons zijn <details> en werken zonder dit bestand;
   de gallery swipet zonder dit bestand ook gewoon door. */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function gallery(root) {
    var track = root.querySelector('[data-mc-track]');
    var host = root.querySelector('[data-mc-dots]');
    var tiles = Array.prototype.slice.call(root.querySelectorAll('[data-mc-tile]'));
    if (!track || !host || tiles.length < 2 || host.children.length) return;

    var dots = tiles.map(function (tile, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'mc-pdp__dot';
      dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
      dot.setAttribute('aria-label', (host.dataset.mcDotsLabel || 'Image %d').replace('%d', i + 1));
      dot.addEventListener('click', function () {
        tile.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
        mark(i);
      });
      host.appendChild(dot);
      return dot;
    });

    function mark(index) {
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', i === index ? 'true' : 'false'); });
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) mark(tiles.indexOf(e.target)); });
      }, { root: track, threshold: 0.6 });
      tiles.forEach(function (t) { io.observe(t); });
    }
  }

  function objection(item) {
    var q = item.querySelector('[data-mc-q]');
    var a = item.querySelector('[data-mc-a]');
    if (!q || !a) return;
    q.addEventListener('click', function () {
      var open = q.getAttribute('aria-expanded') === 'true';
      q.setAttribute('aria-expanded', open ? 'false' : 'true');
      a.hidden = open;
    });
  }


  /* --- ankersprong -----------------------------------------------------
     /#the-depth en /#our-story komen uit het navigatiemenu. De browser
     probeert die sprong tijdens het parsen, maar daarna groeit de pagina nog
     door lazy-loaded beelden en de webfonts — het doel schuift weg onder de
     sprong en de bezoeker landt bovenaan. Gemeten op de live home: hash
     goed, scrollY 0.

     Daarom corrigeren we na 'load' nog een keer. Heeft de bezoeker zelf al
     gescrold, dan laten we hem met rust — niets is vervelender dan een
     pagina die onder je duim wegspringt. */
  function anchorJump() {
    if (!location.hash) return;

    var target;
    try { target = document.querySelector(location.hash); } catch (e) { return; }
    if (!target) return;

    var userScrolled = false;
    ['wheel', 'touchmove', 'keydown'].forEach(function (evt) {
      window.addEventListener(evt, function () { userScrolled = true; }, { passive: true, once: true });
    });

    function go() {
      if (userScrolled) return;
      target.scrollIntoView({ behavior: 'auto', block: 'start' });
    }

    go();
    window.addEventListener('load', go);
    setTimeout(go, 400);
  }


  /* --- menu sluiten én naar het anker springen ---------------------------
     "The depth" en "Our story" wijzen naar secties op de homepage. Sta je er
     al, dan navigeert de browser niet, en dan gebeurden er twee dingen mis:

     1. Het menu had geen aanleiding om te sluiten en bleef over de sectie
        staan waar je net naartoe wilde.
     2. Ook mét sluiten sprong de pagina niet. Gemeten: hash op #the-depth,
        menu dicht, maar scrollY bleef 6 terwijl het doel op 1295px stond.
        De drawer bewaart namelijk de scrollpositie bij openen en zet die bij
        sluiten terug — ná de ankersprong van de browser. Je werd dus
        teruggezet naar boven.

     Daarom nemen we de sprong hier zelf over: sluiten, en daarna springen,
     zowel op de volgende frames als met een marge na de sluitanimatie. */
  function drawerLinks() {
    var drawer = document.querySelector('header-drawer');
    if (!drawer || typeof drawer.close !== 'function') return;

    drawer.addEventListener('click', function (event) {
      var link = event.target.closest ? event.target.closest('a[href]') : null;
      if (!link) return;

      var url;
      try { url = new URL(link.href, location.href); } catch (err) { drawer.close(); return; }

      var target = null;
      if (url.hash && url.pathname === location.pathname) {
        try { target = document.querySelector(url.hash); } catch (err) { target = null; }
      }

      drawer.close();
      if (!target) return;

      /* Bewust GEEN preventDefault: de browser doet zijn eigen ankersprong,
         die aantoonbaar werkt. Wij corrigeren er alleen achteraan, omdat het
         thema de bewaarde scrollpositie terugzet als de drawer sluit. Valt
         onze correctie weg, dan blijft de sprong van de browser staan — dat
         is veiliger dan de standaard vervangen door iets eigens. */
      function corrigeer() {
        var r = target.getBoundingClientRect();
        if (Math.abs(r.top) < 80) return;      /* al goed, niets doen */
        target.scrollIntoView({ behavior: 'auto', block: 'start' });
      }

      requestAnimationFrame(function () {
        requestAnimationFrame(corrigeer);
      });
      setTimeout(corrigeer, 400);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-mc-gallery]').forEach(gallery);
    (root || document).querySelectorAll('[data-mc-objection]').forEach(objection);
  }

  init(document);
  anchorJump();
  drawerLinks();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
